/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Email_ResendInputs */

const en_task_email_resend = /** @type {(inputs: Task_Email_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend email`)
};

const pt_br2_task_email_resend = /** @type {(inputs: Task_Email_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar e-mail`)
};

/**
* | output |
* | --- |
* | "Resend email" |
*
* @param {Task_Email_ResendInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_resend = /** @type {((inputs?: Task_Email_ResendInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_ResendInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_resend(inputs)
	return pt_br2_task_email_resend(inputs)
});